import { useEffect, useState } from 'react';
import { Api } from '../../../componentes/Api';
import { Card, Col,Row, CardBody, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter } from "reactstrap"
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';
import Moment from "moment";
import DatePicker from "react-datepicker";
import * as XLSX from "xlsx"


const modeloDatos = {
    registroID:0,
      empresaID: 1,
       comercio: ''
    , rnc: "",
    mes: 0,
    ano:0
    , ncf: ""
    , fechaFactura: new Date,
     fecha: new Date,
     montoItbs: ""
    , montoTotal: ""
    , comentario: "",
      creadoPor: "",
    modificadoPor: "",
    fechaCreado: new Date,
    fechaModificado: new Date

}

const Seleccion = {
    mes: new Date().getMonth() + 1,
    ano: new Date().getFullYear()
}

const Reclamaciones = () => {
    const [tabla, setTabla] = useState(modeloDatos);
    const [Listado, SetListado] = useState([]);
    const [pendiente, setPendiente] = useState(true);
    const [verModal, setVerModal] = useState(false);
    const [fechaInicio, setFechaInicio] = useState(new Date());
    const [user, setUser] = useState(window.localStorage.getItem("sesion_usuario"))
    const [Visualizar, setVisualizar] = useState(false);
    const [Select, setSelect] = useState(Seleccion);



    const handleChange = (e) => {
        let value = e.target.nodeName === "SELECT" ? (e.target.value == "true" ? true : false) : e.target.value;

        if (e.target.name == "rnc" && e.target.value.length > 8) {
            ValidarRNC(e.target.value);
              
        }

        setTabla({
            ...tabla,
            [e.target.name]: value
        })
    }


    const ValidarRNC = async (x) => {
       let response1 = await fetch(Api + "DGII/ConsultaDGII" + "/" + x);
        if (response1.ok) {
            let data1 = await response1.json()
            if (data1 != false) {
                setTabla({
                    ...tabla, comercio: (data1).descripcion, rnc: x
                })
            } else {
                setTabla({
                    ...tabla, comercio: "", rnc: x
                })
}
           
        }
    }

    const handleChange1 = (e) => {
        setSelect({
            ...Select,
            [e.target.name]: e.target.value
        })
       
    }

    let correo = JSON.parse(user).correo;
    const obtenerDatos = async () => {
        let response = await fetch(Api + "DGII/ListaRegistroFacturaNCF" + "/" + correo + "/" + Select.mes + "/" + Select.ano);
        if (response.ok) {
            let data = await response.json()
            SetListado(data)
            setPendiente(false)



        }
    }

    useEffect(() => {
        obtenerDatos();
    })


    const mostrarMensaje = () => {
        Swal.fire({
            title: 'ERROR',
            text: "No puedes guardar si hay un elemento Activo.  Favor inactivar el elemento. ",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            //confirmButtonText: 'Si, continuar',
            cancelButtonText: 'volver'
        }).then((result) => {
            //alert(result.value)
            if (result.value) {


            }
        })

    }


    const guardarCambios = async () => {
        let response;
        
        tabla.ano = new Date( tabla.fechaFactura).getFullYear();
            tabla.mes = new Date(tabla.fechaFactura).getMonth() + 1;

        if (tabla.registroID == 0) {
           
            tabla.creadoPor = JSON.parse(user).correo;
            response = await fetch(Api + "DGII/GuardarRegistroFacturaNCF", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })
            setVerModal(!verModal);
        } else {
            tabla.modificadoPor = JSON.parse(user).correo;
            response = await fetch(Api + "DGII/EditarRegistroFacturaNCF", {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })
        }

        if (response.ok) {
            Swal.fire(
                'Guardado!',
                '',
                'success'
            )
            if (tabla.activa == false) {
                setTabla(modeloDatos);
                setVerModal(!verModal);
               
            }
            let data1 = await response.json()

            if (data1 == false) {
                mostrarMensaje()
            } else {
                //await obtenerDatos();
                setTabla(modeloDatos)
                setVerModal(!verModal);
            }

        } else {
            alert("error al guardar")
        }

    }

    const eliminarDatos = async (id) => {

        Swal.fire({
            title: 'Esta seguro?',
            text: "Desea eliminar el producto",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, continuar',
            cancelButtonText: 'No, volver'
        }).then((result) => {
            if (result.value) {
                const response = fetch(Api + "Citas/EliminarEspecialistas/" + id, { method: "DELETE" })
                    .then(response => {
                        if (response.ok) {
                            //obtenerDatos();
                            Swal.fire(
                                'Eliminado!',
                                'El producto fue eliminado.',
                                'success'
                            )
                        }
                    })
            }
        })
    }

    const exportarExcel = () => {
        var wb = XLSX.utils.book_new();
        

        var ws = XLSX.utils.json_to_sheet(Listado);
        XLSX.utils.book_append_sheet(wb, ws, "Reporte");
        XLSX.writeFile(wb, "Reporte Factura NCF" + Select.mes +Select.ano+".xlsx")
    }


    const abrirEditarModal = (data) => {
        setTabla(data);
        setVerModal(!verModal);
    }
    const cerrarModal = () => {
        setTabla(modeloDatos)
        setVerModal(false)
    }

    const columns = [
        {
            name: 'ID',
            selector: row => row.rnc,
            sortable: true,
        },
        {
            name: 'Comercio ',
            selector: row => row.comercio,
            sortable: true,
        },
        {
            name: 'NCF ',
            selector: row => row.ncf,
            sortable: true,
        },
        {
            name: 'ITBS ',
            selector: row => row.montoItbs,
            sortable: true,
        },
       
        {
            name: '',
            cell: row => (
                <>
                    <Button color="primary" size="sm" className="mr-2"
                        onClick={() => abrirEditarModal(row)}
                    >
                        <i className="fas fa-pen-alt"></i>
                    </Button>


                </>
            ),
        },
    ];

    const customStyles = {
        headCells: {
            style: {
                fontSize: '13px',
                fontWeight: 800,
            },
        },
        headRow: {
            style: {
                backgroundColor: "#eee",
            }
        }
    };

    const paginationComponentOptions = {
        rowsPerPageText: 'Filas por página',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos',
    };

    return (
        <>
            <Card>
                <CardHeader style={{ backgroundColor: '#4e73df', color: "white" }}>
                    Lista de Registros de NCF para el mes
                </CardHeader>
                <CardBody>
                

                    <Row className="align-items-end">
                        <Col sm={3}>
                            <FormGroup>
                            <Button color="success" size="sm"
                                onClick={() => setVerModal(!verModal)}
                                >Nuevo Registro</Button>
                                </FormGroup>
                        </Col>

                        <Col sm={3}>
                            <FormGroup>
                                <Label>Mes:</Label>

                                <Input bsSize="sm" type={"select"} onChange={handleChange1} name="mes" value={Select.mes} >
                                    <option value={0}>Todo el Año</option>
                                    <option value={1}>Enero</option>
                                    <option value={2}>Febrero </option>
                                    <option value={3}>Marzo</option>
                                    <option value={4}>Abril </option>
                                    <option value={5}>Mayo</option>
                                    <option value={6}>Junio </option>
                                    <option value={7}>Julio</option>
                                    <option value={8}>Agosto </option>
                                    <option value={9}>Septiembre</option>
                                    <option value={10}>Octubre </option>
                                    <option value={11}>Noviembre</option>
                                    <option value={12}>Diciembre </option>
                                </Input>
                            </FormGroup>
                        </Col>

                        <Col sm={3}>
                            <FormGroup>
                                <Label>Año:</Label>
                                <Input name="ano" id="ano" onChange={handleChange1} value={Select.ano}></Input>
                            </FormGroup>
                        </Col>

                        <Col sm={3}>
                            <FormGroup>
                                <Button color="primery" size="sm" block onClick={exportarExcel}>
                                    <i className="fa fa-file-excel" aria-hidden="true"></i> Exportar
                                </Button>
                            </FormGroup>
                        </Col>

                    </Row>
                    <hr></hr>
                    <DataTable
                        columns={columns}
                        data={Listado}
                        progressPending={pendiente}
                        pagination
                        paginationComponentOptions={paginationComponentOptions}
                        customStyles={customStyles}
                    />
                </CardBody>
            </Card>

            <Modal isOpen={verModal}>
                <ModalHeader className=" modal-header1">
                    Registro de Factura NCF
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <Col sm={6}>
                            <FormGroup>
                                <Label>RNC </Label>
                                <Input disabled={Visualizar} bsSize="sm" name="rnc" onChange={handleChange} value={tabla.rnc} />
                            </FormGroup>
                        </Col>
                        <Col sm={6}>
                            <FormGroup>
                                <Label>Comercio</Label>
                                <Input disabled={Visualizar}  bsSize="sm" name="comercio" onChange={handleChange} value={tabla.comercio} />

                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                       <Col sm={6}>
                            <FormGroup>
                                <Label>Fecha de la Factura</Label>
                                <Input disabled={Visualizar} bsSize="sm" type="date" name="fechafactura" onChange={handleChange} value={Moment(tabla.fechaFactura).format('YYYY-MM-DD')} />

                            </FormGroup>
                        </Col>
                        <Col sm={6}>
                            <FormGroup>
                                <Label>NCF </Label>
                                <Input disabled={Visualizar} bsSize="sm" name="ncf" onChange={handleChange} value={tabla.ncf} />
                            </FormGroup>
                        </Col>
                       
                    </Row>
                    <Row>
                     <Col sm={6}>
                            <FormGroup>
                                <Label>Monto ITBS</Label>
                                <Input disabled={Visualizar} type="number" bsSize="sm" name="montoItbs" onChange={handleChange} value={tabla.montoItbs} />

                            </FormGroup>
                        </Col>
                        <Col sm={6}>
                            <FormGroup>
                                <Label>Monto Total Factura </Label>
                                <Input disabled={Visualizar} type="number" bsSize="sm" name="montoTotal" onChange={handleChange} value={tabla.montoTotal} />

                            </FormGroup>
                        </Col>
                      
                    </Row>
                    <Row>
                        <Col sm={12}>
                            <FormGroup>
                                <Label>Comentario</Label>
                                <Input disabled={Visualizar} type="textarea" bsSize="sm" name="comentario" onChange={handleChange} value={tabla.comentario} />

                            </FormGroup>
                        </Col>
                      </Row>
                </ModalBody>
                <ModalFooter>
                    <Button size="sm" color="primary"
                        onClick={guardarCambios}
                    >Guardar</Button>
                    <Button size="sm" color="danger"
                        onClick={cerrarModal}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>



        </>
    )

}
export default Reclamaciones;